import React from 'react';
import PropTypes from 'prop-types';
import FrqRubrics from './FrqRubrics';
import McqRationales from './McqRationales';
import { QuestionTypes } from 'legacy/packages/unit-outline/src/constants';

import { ThemeProvider } from '@material-ui/core/styles';
import { apMuiTheme } from 'legacy-packages/ft-cb';
import { fymClient } from 'legacy-src/utility/GraphqlClients';

/**
 * Scoring rubrics container
 * - Prepares the correct scoring rubric component
 * */
const QuestionGuidelines = (props) => {
  const {
    app,
    questions,
    question: learnosityQuestion,
    isPreApSubject,
    guidelinesHelp,
    shouldAutoScroll,
    playerContainer,
  } = props;

  const { reference } = learnosityQuestion;
  const question = questions.find(
    ({ learnosityItemReference }) => learnosityItemReference === reference,
  );
  const Rubric =
    question?.type === QuestionTypes.FREE_RESPONSE_QUESTION
      ? FrqRubrics
      : McqRationales;

  return Rubric ? (
    <ThemeProvider theme={apMuiTheme}>
      <Rubric
        guidelinesHelp={guidelinesHelp}
        app={app}
        isPreApSubject={isPreApSubject}
        learnosityQuestion={learnosityQuestion}
        question={question}
        shouldAutoScroll={shouldAutoScroll}
        fymClient={fymClient}
        playerContainer={playerContainer || document}
      />
    </ThemeProvider>
  ) : null;
};

QuestionGuidelines.propTypes = {
  /**
   * Question list
   * */
  questions: PropTypes.array.isRequired,
  /**
   * Current question
   * */
  question: PropTypes.object.isRequired,
  isPreApSubject: PropTypes.bool.isRequired,
};

export default QuestionGuidelines;
